import React from 'react';
import { IconButton, TrevorIcon } from '@trevor/ui-components';
import { useAppSelector } from '@/store/hooks';
import { getPlatformName } from '@/util/getPlatformName';
import { selectIsUndoStackEmpty } from '../slice';
import { useUndo } from '../hooks/useUndo';

export const UndoButton = () => {
  const isUndoStackEmpty = useAppSelector(selectIsUndoStackEmpty);
  const undo = useUndo();

  const tooltip = `Undo (${
    getPlatformName() === 'Macintosh' ? 'CMD' : 'Ctrl'
  } + z)`;

  return (
    <IconButton
      onClick={undo}
      icon={<TrevorIcon name="undo" $color="#666" />}
      tooltip={tooltip}
      disabled={isUndoStackEmpty}
    />
  );
};
